import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

type SFFaceIconProps = Omit<SvgIconProps, "color"> & {
  color?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
};

export default function SFFaceIcon({
  color = "white",
  width = 24,
  height = 24,
  strokeWidth = 2,
  ...props
}: SFFaceIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_113_4027)">
          <path
            d="M6.88867 8.18594V10.7092"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M17.6757 8.18594V10.7092"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M12.506 8.1535V12.5708C12.506 13.6735 12.0325 14.147 10.9298 14.147"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M15.7816 17.6497C13.8876 19.2259 10.106 19.2259 8.21191 17.6497"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M0.648682 5.76V4.43027C0.648682 1.75135 1.75138 0.648651 4.4303 0.648651H5.75355"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M5.76003 23.3514H4.4303C1.75138 23.3514 0.648682 22.2487 0.648682 19.5697V18.2465"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M23.3513 18.24V19.5632C23.3513 22.2486 22.2486 23.3513 19.5697 23.3513H18.2465"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M18.24 0.648651H19.5632C22.2486 0.648651 23.3513 1.75135 23.3513 4.43027V5.75352"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_113_4027">
            <rect width={width} height={height} fill={color} />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
